import {
  Box,
  Button,
  Modal,
  ModalProps,
  styled,
  Typography,
} from "@mui/material";

import { theme } from "../mui-customs/Theme";

type PhotoDeleteConformationModal = Omit<ModalProps, "children"> & {
  handleDelete?: () => void;
};

const StyledButton = styled(Button)`
  text-transform: none;
  box-shadow: none;
  border-radius: 6px;
  padding: 8px 32px;
  :hover {
    box-shadow: none;
  }
`;

const PhotoDeleteConformationModal = ({
  open,
  handleDelete,
  ...props
}: PhotoDeleteConformationModal) => {
  return (
    <Modal
      sx={{ display: "grid", placeItems: "center" }}
      open={open}
      {...props}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: "330px",
          padding: 5,
          backgroundColor: theme.whiteBg.WBG1,
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: 6,
        }}
      >
        <Typography variant="h6" sx={{ color: theme.brand2[900], mb: 2 }}>
          Important message
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: theme.black[700], textAlign: "center" }}
        >
          This action is not reversible. It will permanently remove the image.
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <StyledButton
            onClick={(event) => {
              props.onClose && props.onClose(event, "backdropClick");
            }}
            variant="contained"
            sx={{
              backgroundColor: theme.grey1[200],
              ":hover": {
                backgroundColor: theme.grey1[300],
              },
            }}
          >
            Close
          </StyledButton>
          <StyledButton
            onClick={handleDelete}
            variant="contained"
            sx={{
              backgroundColor: theme.brand2[900],
              color: theme.whiteBg.WBG1,
              ":hover": {
                backgroundColor: theme.brand2[900],
              },
            }}
          >
            Delete
          </StyledButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default PhotoDeleteConformationModal;
